import React from 'react';
import { IconProps } from '../types';
const MinecraftLight09: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="0" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="0" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="0" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="0" y="1" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="1" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="2" y="1" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="1" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="0" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="0" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(238, 190, 70, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(82, 80, 78, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(199, 121, 40, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(165, 111, 55, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(199, 121, 40, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(199, 121, 40, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(243, 201, 153, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(199, 121, 40, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(255, 245, 197, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(199, 121, 40, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(204, 202, 202, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(204, 202, 202, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(255, 248, 227, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(236, 166, 61, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(254, 211, 166, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(216, 164, 79, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(216, 164, 79, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(129, 106, 119, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(89, 89, 89, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(129, 106, 119, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(204, 202, 202, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(204, 202, 202, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(89, 89, 89, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(89, 89, 89, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(204, 202, 202, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(139, 127, 133, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(89, 89, 89, 255)" />
</svg>);
export default MinecraftLight09;